import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export const reactPlugin = new ReactPlugin();

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    disableFetchTracking: true,
    disableAjaxTracking: true,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains: ["pcs-dev.fujairahport.ae", "pcs.fujairahport.ae"],
    extensions: [reactPlugin] as never,
  },
});

if (connectionString) {
  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((item) => {
    item.data = item.data || {};

    item.data.appVersion = import.meta.env.VITE_APP_VERSION || "unknown";

    item.data.environment = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "unknown";
  });
}
